import { render, staticRenderFns } from "./p-unique-textfield.vue?vue&type=template&id=a8bdeb52&"
import script from "./p-unique-textfield.vue?vue&type=script&lang=js&"
export * from "./p-unique-textfield.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports